module.exports = __webpack_public_path__ + "img/goods16_6.fe920d4e.jpg";